(() => {
  const root = document.querySelector("[data-griffe-ranges]");
  if (!root) return;

  const art = root.querySelector(".gj-range-art");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const rangeLink = document.querySelector("[data-range-link]");
  const formsLink = root.querySelector("[data-forms-link]");
  const sectionLinks = [formsLink, root.querySelector("[data-study-link]")].filter(Boolean);
  let scrollFrame = 0;
  let navigationFrame = 0;
  let pointerFrame = 0;
  let targetX = 0;
  let targetY = 0;
  let currentX = 0;
  let currentY = 0;

  const clamp = (value) => Math.max(0, Math.min(1, value));
  const pageTop = (element) => window.scrollY + element.getBoundingClientRect().top;

  const animateScroll = (targetYPosition, hash, duration = 1250) => {
    window.cancelAnimationFrame(scrollFrame);
    const startY = window.scrollY;
    const distance = targetYPosition - startY;
    const actualDuration = reduceMotion.matches ? 0 : duration;

    if (!actualDuration || Math.abs(distance) < 2) {
      window.scrollTo({ top: targetYPosition, left: 0, behavior: "instant" });
      window.history.replaceState(null, "", hash);
      return;
    }

    const startedAt = performance.now();
    const step = (now) => {
      const linear = clamp((now - startedAt) / actualDuration);
      const eased = 0.35 * linear + 2.3 * linear * linear - 1.65 * linear * linear * linear;
      window.scrollTo({ top: startY + distance * eased, left: 0, behavior: "instant" });
      if (linear < 1) {
        scrollFrame = requestAnimationFrame(step);
      } else {
        scrollFrame = 0;
        window.history.replaceState(null, "", hash);
      }
    };
    scrollFrame = requestAnimationFrame(step);
  };

  rangeLink?.addEventListener("click", (event) => {
    event.preventDefault();
    animateScroll(pageTop(root), "#gammes", 650);
  });

  formsLink?.addEventListener("click", (event) => {
    event.preventDefault();
    const forms = document.querySelector("[data-griffe-forms]");
    if (!forms) return;
    forms.dispatchEvent(new CustomEvent("griffe:show-forms"));
  });

  const updateNavigationState = () => {
    navigationFrame = 0;
    const rect = root.getBoundingClientRect();
    const center = window.innerHeight * 0.5;
    const isActive = rect.top <= center && rect.bottom > center;
    root.classList.toggle("is-section-active", isActive);
    sectionLinks.forEach((link) => {
      link.setAttribute("aria-hidden", String(!isActive));
      link.tabIndex = isActive ? 0 : -1;
    });
  };

  const requestNavigationUpdate = () => {
    if (!navigationFrame) navigationFrame = requestAnimationFrame(updateNavigationState);
  };

  const updatePointer = () => {
    currentX += (targetX - currentX) * 0.085;
    currentY += (targetY - currentY) * 0.085;
    root.style.setProperty("--gj-range-pointer-x", currentX.toFixed(3));
    root.style.setProperty("--gj-range-pointer-y", currentY.toFixed(3));
    if (Math.abs(targetX - currentX) > 0.002 || Math.abs(targetY - currentY) > 0.002) {
      pointerFrame = requestAnimationFrame(updatePointer);
    } else {
      pointerFrame = 0;
    }
  };

  document.addEventListener("pointermove", (event) => {
    if (reduceMotion.matches || window.innerWidth <= 760) return;
    targetX = clamp(event.clientX / window.innerWidth) * 2 - 1;
    targetY = clamp(event.clientY / window.innerHeight) * 2 - 1;
    if (!pointerFrame) pointerFrame = requestAnimationFrame(updatePointer);
  }, { passive: true });

  const observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    root.classList.add("is-visible");
    window.setTimeout(() => art?.classList.add("is-settled"), reduceMotion.matches ? 0 : 1900);
    observer.disconnect();
  }, { threshold: 0.2 });

  observer.observe(root);
  window.addEventListener("scroll", requestNavigationUpdate, { passive: true });
  window.addEventListener("resize", requestNavigationUpdate, { passive: true });
  updateNavigationState();
})();
